import React from 'react';
import { View, Text, StyleSheet, Pressable } from 'react-native';
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';

interface ModalHeaderProps {
    sessionTitle: string;
    isCoach: boolean;
    onClose: () => void;
}

const ModalHeader: React.FC<ModalHeaderProps> = ({ sessionTitle, isCoach, onClose }) => {
    return (
        <View style={styles.header}>
            <View style={styles.headerLeft}>
                <Text style={styles.modalTitle}>{sessionTitle}</Text>
                <Text style={styles.modalSubtitle}>
                    {isCoach ? 'Coach Dashboard' : 'Student Dashboard'}
                </Text>
            </View>
            <Pressable onPress={onClose} style={styles.closeButton}>
                <MaterialCommunityIcons name="close" size={24} color="#666" />
            </Pressable>
        </View>
    );
};

const styles = StyleSheet.create({
    header: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: 24,
        borderBottomWidth: 1,
        borderBottomColor: '#f0f0f0',
        backgroundColor: '#fafafa',
    },
    headerLeft: {
        flex: 1,
    },
    modalTitle: {
        fontSize: 24,
        fontWeight: '700',
        color: '#1a1a1a',
        marginBottom: 4,
    },
    modalSubtitle: {
        fontSize: 16,
        color: '#666',
        fontWeight: '500',
    },
    closeButton: {
        width: 40,
        height: 40,
        borderRadius: 20,
        backgroundColor: '#f5f5f5',
        alignItems: 'center',
        justifyContent: 'center',
    },
});

export default ModalHeader;

